module.exports = __webpack_public_path__ + "img/cir3.a26b75f6.png";